const styles = theme => ({
    categoryContainer: {
        display: 'flex',
        height: '100%',
        position: 'relative',
        width: '100%'
    },
    categoryLabel: {
        marginLeft: '12px',
        marginRight: '12px',
        overflow: 'hidden',
        paddingLeft: 0,
        paddingRight: 0,
        width: '100%'
    },
    categoryTextContainer: {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        height: '100%',
        paddingRight: '2%',
        position: 'absolute',
        width: '100%'
    },
    chip: {
        backgroundColor: theme.palette.white.dark,
        cursor: 'pointer',
        height: '70%',
        marginLeft: theme.spacing(1),
        opacity: 0.8
    },
    hoverObserver: {
        display: 'flex',
        height: '24px',
        marginBottom: '2px',
        position: 'relative',
        width: '95%'
    },
    notAllowedCategory: {
        cursor: 'wait'
    },
    ratioLabel: {
        fontSize: '12px'
    },
    tooltipLabel: {
        fontSize: '12px',
        marginBottom: '2px',
        marginTop: '2px'
    }
});

export default styles;
